import React, {Component} from 'react';
import {withRouter} from 'react-router';
import { connect } from 'react-redux';

import GenderIcon from 'components/GenderIcon';
import ProfileAvatar from 'components/ProfileAvatar';

import paths from 'paths';
import { formatDateDMY, formatDateHM } from 'utils/formatDate';

import { Link, Redirect } from 'components/ReactRouterDomLocalized';
import { getLangPrefix } from 'l10n';

import PmConversationItemMessage from 'pm-js/build/components/PmConversationItemMessage';
import PmStatusIcon from 'components/pm/PmStatusIcon';

class PmListItem extends Component {

    constructor(props) {
        super(props);
        this.openConversation = this.openConversation.bind(this);

        this.state = {

        };
    }

    openConversation() {
        if (this.props.onClick) {
            this.props.onClick(this.props.conversation);
        } else {
            const conversation = this.props.conversation;
            this.props.history.push(this.props.pathFn(conversation.user.uid));
            this.props.dispatch({type: "PM_WINDOW_MAXIMIZE", conversation: conversation, user:conversation.user})
        }
    }

    render() {
        const conversation = this.props.conversation;

        const profile = conversation.user;
        const conversation_id = conversation.user.uid;
        const old = !conversation.unread;
        const message = conversation.generalStatus == 'allowed' ?
            (conversation.messages.length != 0 ? conversation.messages[conversation.messages.length - 1] : false) : false;
        const date = new Date(conversation.modified * 1000);
        
        let classes = ["pm-list-item"];
        if (conversation.view.maximized) classes.push("active");

        return (
            <div className={classes.join(" ")} onClick={this.openConversation}>
                    <div className="unread-indicator-container"><PmStatusIcon conversation={conversation}/></div>
                    <div className="avatar"><ProfileAvatar user={profile} /></div>
                    
                        <div className="name-one-message">
                            <GenderIcon user={profile} />
                            <span className={`nick ${!old ? 'new' : ''}`}>{profile.nick}</span>
                            {message ? <div><PmConversationItemMessage conversation={conversation} message={message}/></div> : null}
                        </div>
                       
                    
                {date ? 
                    <div className="time">
                        <p className={!old ? 'new' : ''} title={formatDateHM(date)}>{formatDateDMY(date)}</p>
                    </div>
                : null}
            </div>
        )
    }
}

export default connect(
    state => ({
    }),
    null
)(withRouter(PmListItem));


// WEBPACK FOOTER //
// ./src/components/pm/PmListItem.js